import { render, staticRenderFns } from "./UserCard.vue?vue&type=template&id=76b39c16"
import script from "./UserCard.js?vue&type=script&lang=js&external"
export * from "./UserCard.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports